import { render, staticRenderFns } from "./ContentStatus.vue?vue&type=template&id=809a0a78&scoped=true&"
import script from "./ContentStatus.vue?vue&type=script&lang=js&"
export * from "./ContentStatus.vue?vue&type=script&lang=js&"
import style0 from "./ContentStatus.vue?vue&type=style&index=0&id=809a0a78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "809a0a78",
  null
  
)

export default component.exports